import React, { CSSProperties, HTMLAttributes } from 'react';
import styles from './Layout.module.scss';
import { classes } from '../../../lib/utils/cssUtils';
import { useInternalComponent } from '../../../lib/context/InternalComponentContext';

type LayoutContainerProps = {
  className?: string;
  children: React.ReactNode;
  style?: CSSProperties;
  overflow?: 'hidden' | 'visible';
} & HTMLAttributes<HTMLDivElement>;

const LayoutContainer = ({ className, children, style, overflow = 'hidden', ...rest }: LayoutContainerProps) => {
  const { internal } = useInternalComponent();
  const containerStyle = overflow === 'hidden' ? styles.container : styles.containerNoOverflow;

  return React.createElement(
    internal ? 'div' : 'section',
    {
      ...(style ? { style } : null),
      className: classes(className, { [containerStyle]: !internal }),
      ...rest,
    },
    children,
  );
};

export default LayoutContainer;
